import { Button as MuiButton, styled } from '@mui/material';
export * from './containedButton';
export * from './outlinedButton';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
  }
}

type Props = {
  minWidth?: string;
  small?: boolean;
};

export const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== 'minWidth' && prop !== 'small'
})((props: Props) => ({
  height: props.small ? '36px' : '48px',
  minWidth: props.minWidth ?? '144px',
  borderRadius: '16px',
  fontSize: '1rem'
}));
